var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('site-header',{attrs:{"configuration":_vm.configuration}}),_vm._v(" "),_c('div',[_c('nuxt')],1),_vm._v(" "),(_vm.$route.path !== '/transaction' && _vm.$route.path !== '/commande')?_c('site-footer'):_vm._e(),_vm._v(" "),_c('modals-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }